module.exports = __webpack_public_path__ + "img/18.e591c3d2.png";